import Component from "./Component";
import {resolveContainer} from "./domUtils";
import IntegrationError from "../IntegrationError";
import Controller from "../controller/Controller";
import {ComponentType} from "../types";
import {COMPANY_NAME_LOWER_CASE} from "../../env";

export const COMPONENT_TYPES = [
    ComponentType.CARD,
    ComponentType.NUMBER,
    ComponentType.EXPIRY,
    ComponentType.EXPIRY_YEAR,
    ComponentType.EXPIRY_MONTH,
    ComponentType.CVC
]

export interface IComponentGroup {
    _controllerId: string

    createComponent(publicKey: string): Component

    createComponent(publicKey: string, options: any): Component

    updateComponentOptions(type: string, options: any): void;

    automount(selector: string): IComponentGroup
}

export default (controller: Controller, options = {}): IComponentGroup => {

    const _options = options || {};
    const components = {};

    const createComponent = (type, options = {}) => {
        if (COMPONENT_TYPES.indexOf(type) === -1) {
            throw new IntegrationError(`Invalid component type "${type}".`)
        }

        if (components[type]) {
            throw new IntegrationError(`Component group can contain only one component with type "${type}".`);
        }

        const componentOptions = {..._options, ...options};

        const component = new Component(controller, type, componentOptions);
        components[type] = component;

        return component;
    };

    const updateComponentOptions = (type, options = {}) => {
        if (!components[type]) {
          throw new IntegrationError(`Component doesn\'t exsist.`);
        }
        components[type].updateOptions(options);
    };

    const _this: IComponentGroup = {
        _controllerId: controller._id,
        createComponent: createComponent,
        updateComponentOptions: updateComponentOptions,
        automount: (selector) => {
            const parent = resolveContainer(selector);
            const divs = parent.getElementsByTagName("div");

            for (let i = 0; i < divs.length; ++i) {
                const div = divs[i];
                const componentName = div.getAttribute(`data-${COMPANY_NAME_LOWER_CASE}`);
                if (componentName) {
                    createComponent(componentName).mount(div);
                }
            }

            return _this;
        }
    };

    return _this
}
